import styled from 'styled-components';

interface AmigoInputContainerProps {
    $isPassword: boolean;
}

export const AmigoInputContainer = styled.div<AmigoInputContainerProps>`
    height: 44px;
    display: flex;
    flex-direction: row;
    align-items: center;
    border: 1px solid #cccccc;
    border-radius: 8px;
    padding: ${({ $isPassword }) => ($isPassword ? '9px 0px 9px 16px' : '9px 16px')};
    gap: 8px;

    &:focus-within {
        border: 1px solid #7d00ff;
    }

    &:focus-within button {
        border-top-color: #7d00ff;
        border-bottom-color: #7d00ff;
    }
`;
export const AmigoInputMainContainer = styled.div`
    background-color: #ffffff;
`;

export const AmigoInputTile = styled.p`
    font-family: Amigo;
    font-weight: 400;
    font-size: 16px;
    line-height: 16px;
    letter-spacing: 0px;
    margin: 0 0 4px 4px;
`;

export const AmigoTextInput = styled.input`
    flex: 1;
    height: 100%;
    outline: none;
    border: none;
    font-family: Amigo;
    font-weight: 400;
    font-size: 16px;
    line-height: 26px;
    letter-spacing: 0px;
`;

export const PWButton = styled.button`
    background-color: #fbfbfd;
    height: 44px;
    width: 40px;
    border-radius: 0 8px 8px 0;
    display: flex;
    justify-content: center;
    align-items: center;
    border-left: 1px solid #cccccc;
    border-top: 1px solid #cccccc;
    border-bottom: 1px solid #cccccc;
    cursor: pointer;
`;

export const AmigoLink = styled.a`
    font-family: Amigo;
    font-weight: 400;
    font-size: 15px;
    line-height: 24px;
    letter-spacing: 0px;
    color: #7d00ff;
    text-decoration: underline;
    text-decoration-style: solid;
    text-decoration-thickness: 1px;
    align-self: center;

    cursor: pointer;

    &:hover {
        opacity: 0.8;
    }

    &:active {
        opacity: 0.6;
    }

    &:focus {
        outline: none;
    }
`;

interface AmigoTextProps {
    $error?: boolean;
}
export const AmigoText = styled.p<AmigoTextProps>`
    font-family: Amigo;
    font-weight: 400;
    font-size: 15px;
    line-height: 24px;
    letter-spacing: 0px;
    color: ${({ $error }) => ($error ? '#ff0000' : '#000000')};
    align-self: center;
`;
